
<dx-tag-box #dx [items]="dataSource()" [valueExpr]="valueExpr()" [displayExpr]="displayExpr()" [value]="computedValue()"
    (onValueChanged)="onValueChanged($event)" (onBlur)="onTouched()" [isValid]="isValid" [maxDisplayedTags]="4" [minSearchLength]="0" [searchEnabled]="true"
    [searchExpr]="displayExpr()" [searchTimeout]="200" [showDataBeforeSearch]="false" [showMultiTagOnly]="false" [showSelectionControls]="true"
    placeholder="None" [inputAttr]="inputAttr()"/>
